module.exports = __webpack_public_path__ + "img/360_step_2.1ad37bfc.png";